module.exports = __webpack_public_path__ + "img/cat-in-space@1x.d58ed1c0.png";